module.exports = __webpack_public_path__ + "img/exit_form.219d6371.webp";